import React from "react";
import PropTypes from "prop-types";
import Skeleton from "react-loading-skeleton";

import DetailOverviewRow from "../../../components/DetailOverviewRow";
import ProductDescriptionMarkdown from "../../../components/ProductDescriptionMarkdown";
import {
    getCategorySlug,
    getCategoryTitle
} from "../../../utilities/categoryFields";

function CategoryDetailOverview({ category }) {
    return (
        <div className="card">
            <div className="card-body">
                <table className="table table-borderless mb-0">
                    <tbody>
                    <DetailOverviewRow title="Titel">
                        {category ? (
                            getCategoryTitle(category)
                        ) : (
                            <Skeleton width={150}/>
                        )}
                    </DetailOverviewRow>
                    <DetailOverviewRow title="Slug">
                        {category ? (
                            getCategorySlug(category)
                        ) : (
                            <Skeleton width={100}/>
                        )}
                    </DetailOverviewRow>
                    <DetailOverviewRow title="Beschrijving">
                        {category ? (
                            <ProductDescriptionMarkdown>
                                {category.description}
                            </ProductDescriptionMarkdown>
                        ) : (
                            <Skeleton count={5}/>
                        )}
                    </DetailOverviewRow>
                    </tbody>
                </table>
            </div>
        </div>
    )
}

CategoryDetailOverview.propTypes = {
    category: PropTypes.object
}

export default CategoryDetailOverview;
